'use strict';

import Vue from 'vue';
import inventoryService from './services/inventory-service';

const SELECTOR = '.header-calendar';

const init = () => {
    document.querySelectorAll(SELECTOR).forEach(el => {
        let keyword_no_filter = false;

        if (el.dataset.keywordNo) {
            keyword_no_filter = el.dataset.keywordNo.split(',');
        }

        const vm = new Vue({
            el,
            data: {
                events: [],
                loading: true,
            },
        });

        inventoryService.getInventory().then(data => {
            // Filters out Talks/Workshops (basically anything that is "related" to an event but not an event itself)
            data = data.filter(perf => perf.event_link);

            if (keyword_no_filter && keyword_no_filter.length) {
                data.forEach(event => {
                    event.keywords.forEach(keyword => {
                        keyword_no_filter.forEach(no => {
                            if (keyword.keyword_no == no) {
                                vm.events.push(event);
                            }
                        });
                    });
                });
            } else {
                vm.events = data;
            }

            vm.events = vm.events.slice(0, 7);

        }).finally(() => {
            vm.loading = false;
        });
    });
};

init();
